import React, { Component, Fragment } from 'react';
import { Contact } from 'components/layouts';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Menu extends Component {

 
  onMessageSend = message => {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT
    });
  };

  onMessageError = message => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  isContactOpen = contactOpen => {
    this.props.isContactOpen(contactOpen);
  }

  render() {
    return (
      <Fragment>
        <ToastContainer hideProgressBar={true} />
        <Contact isContactOpen={this.isContactOpen} onMessageSend={this.onMessageSend} onMessageError={this.onMessageError} /> 
      </Fragment>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/layouts/navbar/menu.js